import UserSpecificDataHelper from '@/Utility/UserSpecificDataHelper';
import { ICoreFrameGridBindingParameter } from '#/DefaultViewExtensionInterfaces';
import Utilities from '@/Utility/Utilities';
import Class from '@/Class';

/**
 * Kann dafür verwendet werden, ein (CF)Grid für das Resizing so zu konfigurieren, 
 * dass die eingestellte Höhe in der UserSpecificData gespeichert wird und beim Laden
 * des Grids der gespeicherte Wert wieder angewandt wird.
 */
export default class GridResizeStorageManager extends Class {
    private savedUserHeight: KnockoutComputed<string>;

    /**
     * @param storageKeyPrefix Der Schlüssel zum Speichern in der UserSpecificData. 
     * Hier wird überlicherweise der vollqualifizierende Name des DetailViewItems verwendet.
     */
    constructor(storageKeyPrefix: string) {
        super();

        if (Utilities.isNullOrUndefinedOrBlank(storageKeyPrefix))
            throw "No storage key prefix provided";

        this.isDisposable = true;
        this.savedUserHeight = UserSpecificDataHelper.loadUserSpecificData<string>(storageKeyPrefix + '_Height', undefined);
    }

    public resetUserData() {
        this.savedUserHeight(undefined);
    }

    /**
     * Konfiguriert die übergebenen Parameter mit der gespeicherten Höhe (falls vorhanden) 
     * und mit der Speicherung der Höhe bei Änderung dieser.
     * @returns Observable, welches true ist, wenn eine gespeicherte Höhe vom User verwendet wurde. Ansonsten false.
     */
    public manage(parameters: Partial<ICoreFrameGridBindingParameter>): KnockoutObservable<boolean> {
        const isCustomized = this.observableOrDefault(false);
        if (this.savedUserHeight() != undefined) {
            parameters.height = this.savedUserHeight;
            isCustomized(true);
        }

        const debouncedSetUserHeight = _.debounce((value: string) => {
            if (this.isDisposed)
                return;

            this.savedUserHeight(value);
        }, 250);
        parameters.onUserResize = height => {
            if (!isCustomized())
                isCustomized(true);

            debouncedSetUserHeight(`${height}px`);
        };
        return isCustomized;
    }
}